import { Pipe, PipeTransform } from '@angular/core';
import { TransportModeHelper } from '@qwyk/core';

@Pipe({ standalone: true, name: 'transportModeTransform' })
export class TransportModeTransformPipe implements PipeTransform {
    transform(loadType: string, transportMode: string, showAirLoadType = false): string | null {
        return TransportModeHelper.transform(loadType, transportMode, showAirLoadType);
    }
}
